import _ from 'lodash';
import Cookies from 'universal-cookie';

import { ROOT_DOMAIN } from '@/services/connections.service';

const COOKIE_NAME_PREFIX = `H_${String(
  process.env.NEXT_PUBLIC_APP_ENV
).toUpperCase()}_`;

export const COOKIE_MAP = {
  FBP: '_fbp',
  FBC: '_fbc',
  GA: '_ga',
  GCL_AW: '_gcl_aw',
  GCL_AU: '_gcl_au',
  MSCLKID: '_uetmsclkid',
  HOST_PORTAL_USER_IDENTITY: `${COOKIE_NAME_PREFIX}HOST_PORTAL_USER_IDENTITY`,
  LIID: 'li_fat_id',
  LEAD_MARKETING_REFERENCES: `${COOKIE_NAME_PREFIX}LEAD_MARKETING_REFERENCES`,
  OPS_PORTAL_USER_IDENTITY: `${COOKIE_NAME_PREFIX}OPS_PORTAL_USER_IDENTITY`,
  SCLID: '_scclid',
  SELECTED_CART: `${COOKIE_NAME_PREFIX}SELECTED_CART`,
  SELECTED_USER_EVENT: `${COOKIE_NAME_PREFIX}SELECTED_USER_EVENT`,
  TTCLID: '_ttclid'
};

const isDevelopment = process.env.NEXT_PUBLIC_APP_ENV === 'development';
const defaultCookieOptions = {
  domain: `.${ROOT_DOMAIN}`,
  doNotParse: false,
  maxAge: 1000 * 3600 * 24 * 30,
  path: '/',
  secure: !isDevelopment
};

const cookies = new Cookies(null, defaultCookieOptions);
const isServer = typeof window === 'undefined';

export const getCookie = ({ name }) => cookies.get(name, defaultCookieOptions);

export const removeCookie = ({ name }) =>
  cookies.remove(name, defaultCookieOptions);

export const setCookie = ({ name, data }) => {
  if (!_.isNumber(data) && _.isEmpty(data)) {
    removeCookie({ name });
  } else {
    cookies.set(name, data, defaultCookieOptions);
  }
  return getCookie({ name });
};

export const getCLIDFromCookie = ({ name }) => {
  const cookieValue = getCookie({ name });
  return cookieValue?.split('.')?.[2];
};

export const getMSCLKIDFromCookie = () => {
  const cookieValue = getCookie({ name: COOKIE_MAP.MSCLKID });
  let msCLKID;
  if (cookieValue) {
    const prefix = '_uet';
    const index = cookieValue.indexOf(prefix);
    if (index !== -1) {
      msCLKID = cookieValue.substring(index + prefix.length);
    }
  }
  return msCLKID;
};
